export default function AddNewQuestion() {
    return (
        <div></div>
    )
};